var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisitors(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.787,
    height: 24.629,
    viewBox: "0 0 38.787 24.629",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "visitor-5_1_",
    "data-name": "visitor-5 (1)",
    transform: "translate(-0.001 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M378.565,556.353a10.2,10.2,0,0,0-6.34-3.071,15.15,15.15,0,0,0-2.881-.082,12.893,12.893,0,0,0-3.35.616A9.14,9.14,0,0,0,359.9,559.9a12.615,12.615,0,0,0-.573,4.42c0,.128.041.16.167.16q10.8,0,21.608,0h.147c0-.041.009-.067.01-.092a12.392,12.392,0,0,0-.349-3.64A9.742,9.742,0,0,0,378.565,556.353Z",
    transform: "translate(-350.671 -539.854)",
    fill: "#ff9f43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M583.163,9.967a5.183,5.183,0,0,0,4.524,1.254,5.509,5.509,0,0,0,3.5-2.167,5.4,5.4,0,0,0,.712-5.817,5.648,5.648,0,0,0-10.753,2.536A5.684,5.684,0,0,0,583.163,9.967Z",
    transform: "translate(-567.159 0)",
    fill: "#ff9f43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    d: "M11.982,555.466c-.14-.061-.265-.118-.391-.169a9.045,9.045,0,0,0-2.991-.623,10.461,10.461,0,0,0-3.983.521,6.5,6.5,0,0,0-3.746,3.146A7.882,7.882,0,0,0,0,562.03c0,.189,0,.378,0,.572h7.53A10.562,10.562,0,0,1,11.982,555.466Z",
    transform: "translate(0 -541.31)",
    fill: "#ff9f43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M1141.439,559.4a.515.515,0,0,0-.04-.179,6.7,6.7,0,0,0-4.008-3.973,8.956,8.956,0,0,0-2.881-.571,10.4,10.4,0,0,0-4.18.606c-.155.059-.306.128-.481.2a10.353,10.353,0,0,1,2.98,3.1,11.638,11.638,0,0,1,1.532,4.015h7.074c0-.033.005-.055.005-.076Q1141.441,560.964,1141.439,559.4Z",
    transform: "translate(-1102.654 -541.315)",
    fill: "#ff9f43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M1137.391,174.2a4.08,4.08,0,0,0,4.072-4.029,3.993,3.993,0,0,0-7.984-.048A3.966,3.966,0,0,0,1137.391,174.2Z",
    transform: "translate(-1106.196 -162.255)",
    fill: "#ff9f43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M169.8,174.2a4.079,4.079,0,0,0,4.07-4.03,3.993,3.993,0,0,0-7.984-.032A3.967,3.967,0,0,0,169.8,174.2Z",
    transform: "translate(-161.892 -162.256)",
    fill: "#ff9f43"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitors);
export default __webpack_public_path__ + "static/media/visitors.cebb84151c5e373b5ce33bb1e66e7fd7.svg";
export { ForwardRef as ReactComponent };